module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mall-header'), _vm._v(" "), _c('mall-bread', [_c('span', [_vm._v("微信支付")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.fullscreenLoading),
      expression: "fullscreenLoading",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    staticClass: "wxpay-div"
  }, [_c('div', [_c('svg', {
    staticClass: "wxpay-div-img",
    attrs: {
      "aria-hidden": "false"
    }
  }, [_c('use', {
    attrs: {
      "fill": "#4CAF50",
      "xlink:href": "#weixinzhifu"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "wxpay-div-span-font"
  }, [_vm._v("微信支付")]), _vm._v(" "), _c('span', {
    staticClass: "wxpay-div-span-total"
  }, [_vm._v("应付总额：")]), _vm._v(" "), _c('span', {
    staticClass: "wxpay-div-span-money"
  }, [_vm._v("￥" + _vm._s(_vm.totalAmount))]), _vm._v(" "), _c('span', {
    staticClass: "wxpay-div-span-line"
  })]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "wxpay-div-content-div"
  }, [_c('span', [_vm._v("收款方：")]), _c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("深圳市东宝信息技术有限公司")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("订单编号：" + _vm._s(_vm.orderNo))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('vue-qr', {
    staticClass: "wxpay-div-QRCode",
    attrs: {
      "logoSrc": _vm.imageUrl,
      "text": _vm.url,
      "size": 400
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "wxpay-div-QRCode-box",
    attrs: {
      "src": require("../../static/images/扫一扫.png")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "wxpay-div-QRCode-font"
  }, [_vm._v("请使用微信扫一扫 扫描二维码完成支付")])], 1), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both",
      "height": "149px"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "left": "0px",
      "bottom": "0px",
      "width": "100%",
      "z-index": "1",
      "text-align": "center",
      "padding": "20px 0",
      "color": "#999999",
      "font-size": "14px"
    }
  }, [_vm._v("\n    Copyright ©2021 深圳市东宝信息技术有限公司 All Rights Reserved\n  ")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "wxpay-div-line"
  }), _vm._v(" "), _c('img', {
    staticClass: "wxpay-div-index-img",
    attrs: {
      "src": require("../../static/images/微信支付.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0219f654!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/wxPay.vue
// module id = 318
// module chunks = 2